(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Encontrar todos os accordions que tenham comportamento "single"
    var accordions = document.querySelectorAll('.accordion[data-accordion-behavior="single"]');
    if (!accordions.length) return;

    accordions.forEach(function (accordion) {
      // Procurar <details> dentro deste accordion
      var detailsElements = accordion.querySelectorAll('details');
      if (!detailsElements.length) return;

      detailsElements.forEach(function (detailsEl) {
        detailsEl.addEventListener('toggle', function () {
          // Só actuamos quando este é aberto
          if (!detailsEl.open) return;

          detailsElements.forEach(function (other) {
            if (other !== detailsEl && other.open) {
              other.open = false;
            }
          });
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
